import store from './store'
import 'index.css'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher'
import { Provider } from 'react-redux'
import './lang'
import Layouts from './layouts'
import styled from '@emotion/styled'
import { THEME_STORAGE } from 'constants/ThemeConstant'
import { onSwitchTheme } from 'store/slices/themeSlice'
import { THEME_CONFIG } from './configs/AppConfig'
import { useEffect } from 'react'
import { notification } from 'components/util-components/FeedbackProvider'

const AppContainer = styled.div(() => ({
  height: '100%',
}))

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}

const isDarkMode = () =>
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

const currentTheme =
  localStorage.getItem(THEME_STORAGE) ||
  (isDarkMode ? 'dark' : THEME_CONFIG.currentTheme)

store.dispatch(onSwitchTheme(currentTheme))


function App() {
  window.dataLayer.push({
    event: 'pageview',
  })
  useEffect(() => {
    const notificationMessage = sessionStorage.getItem('notification')
    if (notificationMessage) {
      setTimeout(() => {
        notification.open({
          message: notificationMessage,
          duration: 5,
        })
      }, 1000)
    }
    sessionStorage.removeItem('notification')
  }, [notification])
  return (
    <AppContainer>
      <Provider store={store}>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <Layouts />
        </ThemeSwitcherProvider>
      </Provider>
    </AppContainer>
  )
}

export default App
